module.exports = __webpack_public_path__ + "media/images/flags/1x1/spm-1c3b9c17a8639a6480f9fa85383b5ce4.svg";